enum BillingsTaxiUnbilledPrivateOrderListingItemStatus {
  FINISHED = "FINISHED",
  CANCELLED = "CANCELLED",
}

export default BillingsTaxiUnbilledPrivateOrderListingItemStatus;
